module.exports = __webpack_public_path__ + "img/c5.50b05070.jpg";